/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiClassificationItemFromJSON, ApiClassificationItemToJSON, } from './ApiClassificationItem';
import { ApiClassificationRulePeriodTypeFromJSON, ApiClassificationRulePeriodTypeToJSON, } from './ApiClassificationRulePeriodType';
import { ApiClassificationVariableFromJSON, ApiClassificationVariableToJSON, } from './ApiClassificationVariable';
import { ApiConditionFromJSON, ApiConditionToJSON, } from './ApiCondition';
import { ApiConversionFromJSON, ApiConversionToJSON, } from './ApiConversion';
import { ApiOperatorFromJSON, ApiOperatorToJSON, } from './ApiOperator';
export function ApiClassificationRuleFromJSON(json) {
    return ApiClassificationRuleFromJSONTyped(json, false);
}
export function ApiClassificationRuleFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'classificationItem': !exists(json, 'classificationItem') ? undefined : ApiClassificationItemFromJSON(json['classificationItem']),
        'condition': !exists(json, 'condition') ? undefined : ApiConditionFromJSON(json['condition']),
        'conditionId': !exists(json, 'conditionId') ? undefined : json['conditionId'],
        'conversion': !exists(json, 'conversion') ? undefined : ApiConversionFromJSON(json['conversion']),
        'conversionId': !exists(json, 'conversionId') ? undefined : json['conversionId'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'id': !exists(json, 'id') ? undefined : json['id'],
        'key': !exists(json, 'key') ? undefined : json['key'],
        'leadStatusId': !exists(json, 'leadStatusId') ? undefined : json['leadStatusId'],
        'locationId': !exists(json, 'locationId') ? undefined : json['locationId'],
        'locationPageTaggerId': !exists(json, 'locationPageTaggerId') ? undefined : json['locationPageTaggerId'],
        'oldCondition': !exists(json, 'oldCondition') ? undefined : json['oldCondition'],
        'operator': !exists(json, 'operator') ? undefined : ApiOperatorFromJSON(json['operator']),
        'pageTagValue': !exists(json, 'pageTagValue') ? undefined : json['pageTagValue'],
        'period': !exists(json, 'period') ? undefined : json['period'],
        'periodType': !exists(json, 'periodType') ? undefined : ApiClassificationRulePeriodTypeFromJSON(json['periodType']),
        'productId': !exists(json, 'productId') ? undefined : json['productId'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'value': !exists(json, 'value') ? undefined : json['value'],
        'variable': !exists(json, 'variable') ? undefined : ApiClassificationVariableFromJSON(json['variable']),
    };
}
export function ApiClassificationRuleToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'classificationItem': ApiClassificationItemToJSON(value.classificationItem),
        'condition': ApiConditionToJSON(value.condition),
        'conditionId': value.conditionId,
        'conversion': ApiConversionToJSON(value.conversion),
        'conversionId': value.conversionId,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'id': value.id,
        'key': value.key,
        'leadStatusId': value.leadStatusId,
        'locationId': value.locationId,
        'locationPageTaggerId': value.locationPageTaggerId,
        'oldCondition': value.oldCondition,
        'operator': ApiOperatorToJSON(value.operator),
        'pageTagValue': value.pageTagValue,
        'period': value.period,
        'periodType': ApiClassificationRulePeriodTypeToJSON(value.periodType),
        'productId': value.productId,
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'value': value.value,
        'variable': ApiClassificationVariableToJSON(value.variable),
    };
}
